import { Component, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { FeatureFlagService, Icons, Color, Orientation } from '@lsq-frontend/common-ui';
import { FeatureFlags } from '@lsq-frontend/fasttrack-shared/app-constants';

@Component({
    selector: 'admin-buyer-eligibility-settings',
    styleUrls: ['./buyer-configuration-section.component.scss'],
    template: `
        <buyer-configuration-section
            [hasClickedSave]="hasClickedSave"
            sectionTitle="Eligibility Settings"
            [showDisplay]="false"
            sectionFormControlName="eligibilitySetting"
        >
            <div style="padding-top: 2.5rem;">
                <div class="row">
                    <div class="col-6 data">
                        <buyer-configuration-eligibility-setting-section
                            style="margin-top: 5px;"
                            class="buyer-configuration-section"
                            [formGroup]="ineligibleDaysBeforeTermsFormGroup"
                            label="Ineligible Days Before Terms"
                            sublabel="Set the number of days before terms that the invoice is eligible for payment."
                            enabledFormControl="ineligibleDaysBeforeTermsEnabled"
                            activeFormControl="ineligibleDaysBeforeTerms"
                        >
                        </buyer-configuration-eligibility-setting-section>
                    </div>
                    <div class="col-6 data">
                        <buyer-configuration-eligibility-setting-section
                            *ngIf="(maxDaysEarlyFeatureFlag$ | async) && !!maxDaysEarlyFormGroup"
                            style="margin-top: 5px;"
                            class="buyer-configuration-section"
                            [formGroup]="maxDaysEarlyFormGroup"
                            label="Maximum Days Paid Early"
                            sublabel="Set the amount of days an invoice can be early paid, limiting the duration capital is deployed to mitigate risk."
                            enabledFormControl="maxDaysEarlyEnabled"
                            activeFormControl="maxDaysEarlyDays"
                            [maxDaysPaid]="true"
                        >
                        </buyer-configuration-eligibility-setting-section>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6 data">
                        <buyer-configuration-eligibility-setting-section
                            style="margin-top: 5px;"
                            class="buyer-configuration-section"
                            [formGroup]="adjustable120DayFormGroup"
                            label="Adjustable 120 Day Rule"
                            sublabel="The default invoice terms funding eligibility rule is 120 days due to our agreement with Bank of America. Changing this requires approval from Finance before overriding this configuration."
                            enabledFormControl="adjustable120DayEnabled"
                            activeFormControl="adjustable120DayActive"
                        >
                        </buyer-configuration-eligibility-setting-section>
                    </div>
                </div>
            </div>
        </buyer-configuration-section>
    `
})
export class AdminBuyerConfigurationEligibilitySettings {
    @Input() public adjustable120DayFormGroup: FormGroup;
    @Input() public ineligibleDaysBeforeTermsFormGroup: FormGroup;
    @Input() public maxDaysEarlyFormGroup: FormGroup;
    @Input() public hasClickedSave: boolean;
    @Input() public decayingFeeFormGroup: FormGroup;
    public eligibilitySettingFormControl: FormControl;

    public readonly icons = Icons;
    public readonly color = Color;
    public readonly orientation: Orientation;

    public maxDaysEarlyFeatureFlag$ = this._featureFlagService.isOn(FeatureFlags.MaxDaysEarly);

    constructor(private _featureFlagService: FeatureFlagService) {}
}
